import moment from 'moment';

export const convertUnixTimestampToNormalDate = (unixDate: number, dateFormat?: string): string => {
  try {
    return moment.unix(unixDate).format(dateFormat ? dateFormat : 'DD/MM/yyyy');
  } catch (err) {
    return '';
  }
};

export const convertUnixTimestampToInputValue = (unixDate: number): string => {
  try {
    return moment(new Date(convertUnixTimestampToNormalDate(unixDate, 'YYYY/MM/DD'))).format(
      'yyyy-MM-DD'
    );
  } catch (err) {
    return '';
  }
};

export const convertDateStringToNormalStringMDY = (str: string) => {
  try {
    return moment(new Date(str)).format('MM/DD/YYYY');
  } catch (err) {
    return '';
  }
};

export const convertDateStringToNormalString = (str: string) => {
  try {
    return moment(new Date(str)).format('DD/MM/YYYY');
  } catch (err) {
    return '';
  }
};

export const convertDateStringToNormalTime = (str: string) => {
  try {
    return moment(new Date(str)).format('HH:mm:ss');
  } catch (err) {
    return '';
  }
};

export const convertDateStringToNormalDateTime = (str: string) => {
  try {
    return moment(new Date(str)).format('DD/MM/yyyy HH:mm');
  } catch (err) {
    return '';
  }
};

export const convertDateStringToString = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);

  // Format to YYYY-MM-DD as required by the date input
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
